import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { EnvironmentService } from '@core/services/environment.service';
import { buildUrl } from '@core/utils/url.utilities';
import { ResponseSessionGrantsDto } from '@kerberos-compliance/compliance-shared-ts/core/iam/authorization/dtos/response.session-grants.dto';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BaseAuthService {
  protected readonly httpClient = inject(HttpClient);

  protected readonly environmentService = inject(EnvironmentService);

  /**
   * Retrieves the list of grants associated with the provided access token.
   *
   * @param {string} accessToken - The access token used for authorization.
   * @returns {Observable<ResponseSessionGrantsDto>} An observable containing grants and organizations.
   */
  public getGrant(accessToken: string): Observable<ResponseSessionGrantsDto> {
    return this.httpClient
      .get<ResponseSessionGrantsDto>(buildUrl(this.environmentService.baseAdpHost, 'grant/session'), {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .pipe(
        map((response) => {
          return {
            grants: response.grants,
            organizations: response.organizations,
          };
        }),
      );
  }
}
